
<div class="h-[340px] pt-[20px] px-5 pb-[10px]">
  <div class="flex justify-center items-center my-4 gap-2">
    <ng-container *ngFor="let star of stars; let i = index">
      <!-- <ion-icon
        [name]="(hoveredRating >= i + 1 || selectedRating >= i + 1) ? 'star' : 'star-outline'"
        (mouseenter)="hoveredRating = i + 1"
        (mouseleave)="hoveredRating = 0"
        (click)="selectRating(i + 1)"
        [ngClass]="{
          'text-[#14192D]': hoveredRating >= i + 1 || selectedRating >= i + 1,
          'text-[#C8C8CD]': hoveredRating < i + 1 && selectedRating < i + 1
        }"
        class="w-[44px] h-[44px] he cursor-pointer"
      ></ion-icon> -->
      <ark-lib-icon-name
        [name]="(hoveredRating >= i + 1 || selectedRating >= i + 1) ? 'star-outline' : 'star'"
        (mouseenter)="hoveredRating = i + 1"
        (mouseleave)="hoveredRating = 0"
        (click)="selectRating(i + 1)"
        class="w-[44px] h-[44px] he cursor-pointer"
       ></ark-lib-icon-name>
    </ng-container>
  </div>
  
  <!-- <div class="w-[60px] h-[60px] rounded-full border-solid border-2 border-[#BEB9B4] text-[36px] text-[#14192D] font-bold text-xl flex items-center justify-center mx-auto mb-4">
    {{ hoveredRating || selectedRating }}
  </div> -->

  <div class="flex flex-col items-center justify-center gap-[10px]">
    <h3 class="text-[24px] leading-[32px]">
      Star Rating
    </h3>

    <div class="text-[16px] text-center text-[#14192D] font-normal leading-[26px] mt-[10px]">
     Rate this {{ entityType }} based on its clarity, logic, validity, and impact.
    </div>
    
    <ark-button 
    class="h-[48px] w-[100px] mt-[10px]"
    (click)="submitRating()"
    >RATE</ark-button>

    <ark-button
    classess="h-[48px] w-[100px]"
    type="light"
    leftIcon="system-left"
    [iconColor]="'cta'"
    class="h-[48px] w-[100px]"
    (click)="closeModal()"
    >Cancel</ark-button>
  </div>
  
</div>